import styled from 'styled-components';
import {
  space,
  layout,
  flexbox,
  border,
  position,
  SpaceProps,
  LayoutProps,
  FlexboxProps,
  BorderProps,
  PositionProps,
} from 'styled-system';

export type ContainerProps = SpaceProps &
  LayoutProps &
  FlexboxProps &
  BorderProps &
  PositionProps &
  Record<string, any>;

export const Container = styled('div')<ContainerProps>(
  space,
  layout,
  flexbox,
  border,
  position,
);
